// CookieTrigger.js
//
// Entry points for reopening the cookie settings (GDPR/DSGVO Art. 7(3)):
//   1. The floating icon/card from templates/trigger.php, if enabled. Every
//      method no-ops when its container is absent.
//   2. Any [data-madcc-open-settings] element, e.g. the [mad_cookie_settings]
//      shortcode. Always available, independent of the floating trigger.
//   3. Any .mad-cc-open-settings element. Same behaviour as 2, as a class so it
//      can be added wherever only a CSS-class field is available — nav menu
//      items, page builder modules, theme buttons.

const OPENER_SELECTOR = "[data-madcc-open-settings], .mad-cc-open-settings";

class CookieTrigger {
  constructor(cookieConsent) {
    this.cookieConsent = cookieConsent;
    this.init();
  }

  init() {
    // Delegated, and bound before the container check below, so it also works
    // with the floating trigger disabled or for markup inserted after load.
    document.addEventListener("click", (event) => {
      const target = event.target;
      if (!target || typeof target.closest !== "function") return;

      const opener = target.closest(OPENER_SELECTOR);
      if (!opener) return;
      event.preventDefault();
      this.onClick();
    });

    this.container = document.querySelector(".mad-cc-trigger__container");
    if (!this.container) return;

    this.button = this.container.querySelector(".mad-cc-trigger");
    if (this.button) {
      this.button.addEventListener("click", () => this.onClick());
    }
  }

  onClick() {
    this.cookieConsent.modal.show();
  }

  show() {
    if (this.container) this.container.classList.add("active");
  }

  hide() {
    if (this.container) this.container.classList.remove("active");
  }

  /**
   * The trigger and the banner share the bottom corners, so the trigger only
   * appears once the banner is gone — i.e. once a decision has been recorded.
   *
   * Call this only from sites that also hide the banner (acceptAll, denyAll,
   * the modal's save handler, and init). CookieConsent.onCookieConsentGiven /
   * onCookieCategoryConsentGiven set `hide_cookie_banner` WITHOUT hiding the
   * banner — the video-consent path relies on that — so syncing from there
   * would draw the trigger on top of a still-visible banner. Those paths pick
   * the trigger up on the next page load via init() instead.
   */
  syncVisibility() {
    if (this.cookieConsent.getCookie("hide_cookie_banner") === "true") {
      this.show();
    } else {
      this.hide();
    }
  }
}

module.exports = CookieTrigger;
